import { useTheme } from 'styled-components';
import { handleColorType } from '@quizzach/styles';

export const QLogo = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 100 100'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M83.3695 28.9437C84.8699 21.2143 83.6923 15.2555 79.8366 11.0672C75.9988 6.78694 68.7549 3.61033 58.1049 1.53737C46.9041 -0.642818 38.5403 -0.504165 33.0134 1.95332C27.5963 4.33667 24.1375 9.39304 22.6371 17.1224L17.8412 41.8289C17.0195 46.0617 16.7998 49.6477 17.182 52.5869C17.5464 55.6181 18.3023 58.1049 19.4498 60.0471C20.5972 61.9893 22.3211 63.6618 24.6213 65.0644C26.8477 66.3572 29.1735 67.3829 31.5987 68.1414C32.9955 68.5783 34.6904 69.0257 36.6836 69.4836C36.9726 69.55 37.7426 69.7186 38.0891 69.7818L41.2589 70.3988C48.2376 71.7572 44.1173 61.873 41.9526 61.4516L39.3263 60.9346C37.5642 60.4245 36.0827 59.8885 34.8819 59.3266C32.546 58.108 31.0057 56.4713 30.2613 54.4165C29.5168 52.3617 29.5107 49.448 30.243 45.6753L34.9854 21.2449C35.8428 16.8281 36.8262 13.725 37.9358 11.9356C39.1372 10.1641 40.994 9.18855 43.5061 9.00906C46.11 8.84745 50.258 9.32062 55.9503 10.4286C60.8162 11.3757 64.3713 12.4497 66.6154 13.6504C68.8775 14.7592 70.3169 16.424 70.9339 18.645C71.5687 20.7739 71.4753 23.9547 70.6536 28.1875L62.0826 72.3655L62.08 72.3787L61.475 75.4954C60.87 78.6121 71.6336 89.4019 73.5841 79.354L83.3695 28.9437Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M70.1815 97.0626C69.7997 99.0298 67.899 100.315 65.9362 99.9328L60.6541 98.9046C58.6913 98.5226 57.4097 96.6182 57.7916 94.651L58.6775 90.0872C60.628 80.0393 71.3915 90.8292 70.7865 93.9459L70.1815 97.0626Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
